import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// import HireMe from "./component/HireMe";
// import Project from "./component/Project";
// import BootstrapNav from "./component/BootstrapNav";
// import KnowMore from "./component/KnowMore";
// import Navbar from "./component/Navbar";
// import Togrther from "./component/Togrther";
// import Touch from "./component/Touch";
// import Resume from "./component/Resume";

import Navbar1 from "./component/navbar/Navbar1";
import Home from "./component/pages/Home";
import ProjectV2 from "./component/ProjectV2";
import About from "./component/About";
import Myskill from "./component/Myskill";
import Footer from "./component/Footer";
import Header from "./component/Header";

function App() {
  return (
    <div className="App ">
      <BrowserRouter>
        <Header />
        <Navbar1 />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/skill&tools" element={<Myskill />}></Route>
          <Route path="/project" element={<ProjectV2 />}></Route>
          <Route path="/about" element={<About />}></Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
